"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCarouselSlideStyles = exports.getCarouselSlidesWrapperStyles = exports.getChevronStyles = exports.getButtonStyles = exports.getRootStyles = void 0;
const styles = {
    root: {
        display: "grid",
        height: "100%",
    },
    slidesWrapper: { position: "relative", overflow: "hidden", width: "100%" },
    carouselSlidesWrapper: {
        position: "absolute",
        top: 0,
        left: 0,
        display: "flex",
    },
    carouselItem: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
    carouselButton: {
        zIndex: 10,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0,0,0, 0.3)",
        color: "#fff",
        height: "1.5rem",
    },
};
const getRootStyles = (isVertical) => ({
    ...(isVertical && { gridTemplateRows: "auto 1fr auto" }),
    ...(!isVertical && { gridTemplateColumns: "auto 1fr auto" }),
});
exports.getRootStyles = getRootStyles;
const getButtonStyles = (isVertical, disabled, shouldRenderButtons) => ({
    ...(disabled && {
        backgroundColor: "rgba(0,0,0, 0.6)",
        pointerEvents: "none",
        color: "#aeafaf",
    }),
    ...(!isVertical && { height: "100%", width: "1.5rem" }),
    ...(!shouldRenderButtons && { height: "0px", width: "0px" }),
});
exports.getButtonStyles = getButtonStyles;
const getChevronStyles = (isVertical, shouldRender, direction) => ({
    width: "1rem",
    ...(isVertical && direction === "up" && { transform: "rotateZ(180deg)" }),
    ...(!isVertical && direction === "up" && { transform: "rotateZ(90deg)" }),
    ...(!isVertical && direction === "down" && { transform: "rotateZ(-90deg)" }),
    ...(!shouldRender && { display: "none" }),
});
exports.getChevronStyles = getChevronStyles;
const getCarouselSlidesWrapperStyles = (isVertical, gap) => ({
    gap: `${gap}px`,
    ...(isVertical && { width: "100%", flexDirection: "column" }),
    ...(!isVertical && { height: "100%", flexDirection: "row" }),
});
exports.getCarouselSlidesWrapperStyles = getCarouselSlidesWrapperStyles;
const getCarouselSlideStyles = ({ isVertical, isLoading, carouselDrivingDimension, gap, currentIndex, }) => ({
    position: "relative",
    ...(!isLoading && { transition: "0.5s ease-in-out" }),
    ...(isVertical && {
        transform: `translate3d(0px, -${currentIndex * carouselDrivingDimension + gap * currentIndex}px, 0px)`,
        height: `${carouselDrivingDimension}px`,
    }),
    ...(!isVertical && {
        transform: `translate3d(-${currentIndex * carouselDrivingDimension + gap * currentIndex}px, 0px, 0px)`,
        width: `${carouselDrivingDimension}px`,
        height: "100%",
    }),
});
exports.getCarouselSlideStyles = getCarouselSlideStyles;
exports.default = styles;
//# sourceMappingURL=styles.js.map